import React from "react";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { PageHero } from "@/components/layout/PageHero";
import { CtaBand } from "@/components/layout/CtaBand";
import { Process } from "@/components/sections/Process";
import { Production } from "@/components/sections/Production";
import { QuotePreview } from "@/components/sections/QuotePreview";

export default function ComeFunziona() {
  return (
    <SiteLayout>
      <PageHero
        testId="come-funziona-page"
        micro="COME FUNZIONA"
        title="Dal file al pezzo, passo dopo passo."
        description="Un percorso chiaro e controllato: analisi tecnica, preventivo, produzione e consegna. Ecco come lavoriamo e come si avvia una richiesta."
      />

      <Process />
      <Production />
      <QuotePreview />

      <CtaBand secondaryTo="/metodo" secondaryLabel="Il metodo Strato" />
    </SiteLayout>
  );
}
